// -----------------------------------------------------------------------------
// Scripts for header menu
// -----------------------------------------------------------------------------

$(function () {
  const subMenuWrapperFirst = $('.header-menu__list > .menu-item > .sub-menu-wrap');

  if(subMenuWrapperFirst.length) {
    subMenuWrapperFirst.addClass('sub-menu-wrap--first');
  }

  $('.header-menu__list .menu-item').hover(function () {
    $(this).find('.sub-menu-wrap--first').fadeIn(300);
  }, function () {
    $(this).find('.sub-menu-wrap--first').fadeOut(300);
  });
});